export default "__VITE_ASSET__Ca5kqyY5__"